import {
  Component, OnInit, forwardRef,
  Input, HostListener, ChangeDetectorRef, EventEmitter, Output, HostBinding, SimpleChanges, OnChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormControl } from '@angular/forms';
export const CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};
@Component({
    selector: 'app-checkbox',
    template: `<div class="form-check">
  <!-- [disabled] keeps the native input in sync: without it a click on the
       input itself flipped the visible tick while the model stayed put -->
  <input class="form-check-input" type="checkbox" [checked]="checked" [disabled]="disabled" >
  <label class="form-check-label" [ngClass]="{'form-check-label':!settings.hide}" >
    {{labelName}}<ng-content></ng-content>
  </label>
</div>`,
    styles: [`.form-check-label:not(.custom-control-label) {
    margin: 0;
    padding-left: 0;
    font-weight: bold !important;
    color: black !important;
    text-transform: none;
  }
`],
    providers: [CHECKBOX_VALUE_ACCESSOR],
    standalone: false
})

export class CheckboxComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() labelName: any;
  @Input() formControl: UntypedFormControl;
  @Input() disabled: boolean;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() value: any;
  @Input() settings = { hide: false }
  @Output() change: EventEmitter<any> = new EventEmitter();
  checked = false;
  onChange = (_f: any) => { };
  onTouched = () => { };

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (typeof this.value === 'boolean') {
      this.checked = this.value;
    }
  }
  @HostListener('click')
  onClick() {
    if (!this.disabled) {
      this.checked = !this.checked;
      if (this.value) {
        const value = this.checked ? this.value : null;
        this.onChange(value);
        this.change.emit(value);

      } else {
        this.change.emit(this.checked);
        this.onChange(this.checked);
      }
    }

  }
  writeValue(obj: any): void {
    this.checked = obj;
    this.cd.markForCheck();
  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

  }

}
